import { EInstance } from 'src/app/project/shared/enums/instances';

export const environment = {
  staging: false,
  development: false,
  production: false,
};

export function setEnvironment(host: string): void {
  switch (host) {
    case EInstance.STAGING:
      environment.staging = true;
      break;
    case EInstance.LIVE:
    case EInstance.ASM:
      environment.production = true;
      break;
    case EInstance.DEVELOPMENT:
      environment.development = true;
      break;
      break;
    default:
      environment.production = false;
      environment.development = false;
      environment.staging = false;
      break;
  }
}
